// extracted by mini-css-extract-plugin
export default {"root_scroller":"yU","flex_container":"zU","container":"AU","scroller":"BU","indicator":"CU","scrollButtons":"EU","selected":"FU","root_tab":"GU","root_tab_scrollable":"HU","root_scroller_mob":"IU","scroller_mob":"JU","indicator_mob":"KU","selected_mob":"LU","root_tab_mob":"MU","root_tab_mob_scrollable":"NU"};
    if(module.hot) {
      // 1713809679277
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  